module.exports = __webpack_public_path__ + "static/media/ktm-16.13d48585.png";